import React, {  useRef, useEffect } from "react";
import i from 'images/buttons/i.svg'
import 'styles/controls/InfoTooltip.sass';
import { useDispatch } from 'react-redux';


export default function InfoTooltip(props) {
  const dispatch = useDispatch();

  useEffect(() => { 
    console.log('render InfoTooltip')
  });

  function mouseEnter(ev) {
    dispatch({ type: 'SET_TOOLTIP', payload: {"title": props.title, "body": props.body, "x": ev.clientX, "y": ev.clientY}})
  } 

  function mouseLeave(ev) {
    dispatch({ type: 'SET_TOOLTIP', payload: undefined})
  }

  return (
    <div className="infoCont" title="">
      <img src={i} onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}/>
    </div>
  )
}
